export default "__VITE_ASSET__DMAbniEV__"